import {
  Col,
  Row,
  Space,
  Table,
  Card,
  Spin,
  message,
  Divider,
  Button,
  Typography,
  Select,
  Input,
  InputNumber,
  Tag,
  Checkbox,
  Dropdown,
  Radio,
} from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  FilterOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  SearchOutlined,
  DownOutlined,
  PrinterOutlined,
  ReloadOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import XLSX from "xlsx-js-style";
import {
  HEADERS_EXPORT_BEN,
  POST_LIST_ENFORCEMENT,
  POST_LOAD_LOST_CONTACT_JUDGE,
  POST_MAIN_LOST_PRE_ENFORCEMENT,
} from "../../API/apiUrls";
import CurrencyFormat from "../../../hook/CurrencyFormat";
import useLawyerNamesNew from "../../../hook/UseLawyerNameNew";
import "../../../assets/font/THSarabunNew-normal";
import "../../../assets/font/THSarabunNew-bold";
import MotionHoc from "../../../utils/MotionHoc";
import TokenCheck from "../../../hook/TokenCheck";
import AssignLawyerModal from "./modal/AssignLawyerModal";
import AssignOnceLawyerModal from "./modal/AssignOnceLawyerModal";

const { Text } = Typography;

const OPTIONS_TYPE = [
  { value: "lsfhp", label: "จำนอง สัญญา 1" },
  { value: "vsfhp", label: "เช่าซื้อบัญชี 2" },
  { value: "sfhp", label: "เช่าซื้อบัญชี 8" },
  { value: "rpsl", label: "P-LOAN" },
];

const OPTIONS_TYPE_WITH_ALL = [
  { value: "all", label: "ทั้งหมด" },
  ...OPTIONS_TYPE,
];

const OPTIONS_CASE_TYPE = [
  { value: 1, label: "ทำยอม" },
  { value: 2, label: "พิพากษา" },
];

const OPTIONS_CASE = [
  { value: 1, label: "ทำยอม" },
  { value: 3, label: "พิพากษามีตารางดิว" },
  { value: 2, label: "พิพากษา" },
];

const GRADE_COLOR = {
  A: "green",
  B: "blue",
  C: "orange",
  D: "volcano",
  X: "default",
};

const getAssetStatus = (record) => {
  const status = record.statusActiveInvestigate;
  return status === null || status === undefined || status === 0
    ? "null"
    : String(status);
};

const getAssetStatusMeta = (status) =>
  ASSET_STATUS_META[status] || ASSET_STATUS_META.null;

const ASSET_STATUS_META = {
  null: { color: "default", label: "ยังไม่ได้ส่งสืบ" },
  1: { color: "orange", label: "รอส่งสืบ" },
  2: { color: "blue", label: "ดำเนินการสืบ" },
  3: { color: "green", label: "เจอทรัพย์" },
  4: { color: "red", label: "ไม่เจอทรัพย์" },
};

const OPTIONS_ASSET_STATUS = [
  { value: "all", label: "ทั้งหมด" },
  { value: "null", label: "ยังไม่ได้ส่งสืบ" },
  { value: "1", label: "รอส่งสืบ" },
  { value: "2", label: "ดำเนินการสืบ" },
  { value: "3", label: "เจอทรัพย์" },
  { value: "4", label: "ไม่เจอทรัพย์" },
];

const OPTIONS_ASSET_TYPE = [
  { value: "all", label: "ทั้งหมด" },
  { value: "1", label: "รถ" },
  { value: "2", label: "ที่ดิน" },
];

const ASSET_TYPE_LABEL_BY_VALUE = {
  1: "รถ",
  2: "ที่ดิน",
};

const getSchemaLabel = (dataType) =>
  OPTIONS_TYPE.find((o) => o.value === dataType)?.label || dataType || "-";

// ทำยอม: flagLoanNew === 1 / พิพากษา(ผ่อนชำระ): flagLoanNew === 2 && flagDue === 1 / พิพากษา: flagLoanNew === 2 && flagDue === 0
const getCaseTypeValue = (r) => {
  if (r.flagLoanNew === 1) return 1;
  if (r.flagLoanNew === 2 && r.flagDue === 1) return 3;
  if (r.flagLoanNew === 2 && r.flagDue === 0) return 2;
  return null;
};

const getAssetTypeLabel = (SCHEMA, STRNO, product) => {
  if (SCHEMA === "lsfhp") return "ที่ดิน";
  if (SCHEMA === "vsfhp") return "รถ";
  if (SCHEMA === "rpsl" || SCHEMA === "psfhp" || SCHEMA === "sfhp") {
    const raw = String(STRNO ?? "").trim();
    if (!raw) return "ไม่ระบุ";

    const hasAlpha = /[a-zA-Z]/.test(raw);
    const hasDigit = /[0-9]/.test(raw);
    if (hasAlpha && hasDigit) return "รถ";

    if (raw.includes("-")) return "รถ";
    if (raw.includes(",")) return "ที่ดิน";

    const digitsOnly = raw.replace(/[()]/g, "");
    if (/^[0-9]+$/.test(digitsOnly)) {
      return digitsOnly.length <= 6 ? "ที่ดิน" : "รถ";
    }

    return "ไม่ระบุ";
  }

  return "ไม่ระบุ";
};

const CASE_TYPE_COLOR = { 1: "gold", 2: "geekblue", 3: "blue" };

// const getCaseTypeLabel = (flagLoanNew, flagDue) =>
//   flagLoanNew === 1
//     ? "ทำยอม"
//     : flagLoanNew === 2 && flagDue === 0
//       ? "พิพากษาปกติ"
//       : flagLoanNew === 2 && flagDue === 1
//         ? "พิพากษาปกติมีตารางดิว"
//         : "-";

const getCaseTypeLabel = (r) =>
  OPTIONS_CASE.find((o) => o.value === getCaseTypeValue(r))?.label || "-";

const formatThaiDate = (d) =>
  d && !String(d).startsWith("0001-01-01")
    ? dayjs(d).add(543, "year").format("DD/MM/YYYY")
    : "-";

// วันที่รูปแบบ export ตามตัวอย่าง (2026-03-05)
const formatDateExport = (d) => (d ? dayjs(d).format("YYYY-MM-DD") : "-");

const Main = () => {
  const [, , currencyFormatPoint] = CurrencyFormat();
  const [signOut] = TokenCheck();
  const { nameLawyers, loadingUseLawyerNames } = useLawyerNamesNew({
    auto: true,
    toast: false,
  });

  const [loading, setLoading] = useState(false);
  const [arrayPay, setArrayPay] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [schemaFilter, setSchemaFilter] = useState("all");
  const [caseTypeFilter, setCaseTypeFilter] = useState([1, 2, 3]);
  const [searchContno, setSearchContno] = useState("");
  const [expMin, setExpMin] = useState(null);
  const [expMax, setExpMax] = useState(null);
  const [lawyerName, setLawyerName] = useState(undefined);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [isOnceModal, setIsOnceModal] = useState(false);
  const [caseType, setCaseType] = useState(1);
  const [lostDaySearch, setLostdaySearch] = useState(1);
  const [hldnoSearch, setHldnoSearch] = useState(4);
  const [assetStatusFilter, setAssetStatusFilter] = useState(["all"]);
  const [assetType, setAssetType] = useState("all");
  const [lostDayFilter, setLostdayFilter] = useState(null);
  const [dataSend, setDataSend] = useState([]);
  const [typeAssetUse, setTypeAssetUse] = useState("all");

  const handleAssetStatusFilterChange = useCallback((values) => {
    if (!values.length) {
      setAssetStatusFilter(["all"]);
      return;
    }
    const last = values[values.length - 1];
    setAssetStatusFilter(
      last === "all" ? ["all"] : values.filter((v) => v !== "all"),
    );
  }, []);

  const getRowKey = useCallback(
    (r) => r.loanNewId ?? `${r.DATA_TYPE}_${r.CONTNO}`,
    [],
  );

  const lawyerOptions = useMemo(
    () =>
      Array.from(
        new Map(
          (nameLawyers ?? [])
            .filter(
              (l) =>
                (l.ROLE_ID === 3 || l.ROLE_ID === 4) &&
                l.ACTIVE_STATUS &&
                l.COMPANY_ID !== 3 &&
                l.id != null &&
                l.NNAME,
            )
            .map((l) => [l.id, { value: l.id, label: l.NNAME }]),
        ).values(),
      ),
    [nameLawyers],
  );

  // ── Query ─────────────────────────────────────────────
  const queryData = useCallback(async () => {
    setLoading(true);
    const payload = {
      userId: 1,
      flagLoanNew: caseType,
      lostDay: lostDaySearch,
      hldno: hldnoSearch,
    };
    try {
      const res = await axios.post(POST_MAIN_LOST_PRE_ENFORCEMENT, payload, {
        headers: HEADERS_EXPORT_BEN,
      });
      const data = Array.isArray(res.data.mixData)
        ? res.data.mixData.filter((item) => item.flagEnforce === 0)
        : [];
      setArrayPay(data);
      setFilteredData(data);
    } catch (err) {
      message.error(
        err?.response?.status === 404 ? "ไม่พบข้อมูล" : "ไม่พบข้อมูล",
      );
      if (err?.response?.status === 401) {
        signOut();
      }
      setArrayPay([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  }, [signOut]);

  // ── Filter (มีผลเฉพาะตอนกดปุ่ม "กรองข้อมูล") ──────────
  const handleFilter = useCallback(() => {
    let filtered = arrayPay;

    if (schemaFilter !== "all") {
      filtered = filtered.filter((d) => d.DATA_TYPE === schemaFilter);
    }
    if (caseTypeFilter.length === 0) {
      filtered = [];
    } else if (caseTypeFilter.length < OPTIONS_CASE_TYPE.length) {
      filtered = filtered.filter((d) =>
        caseTypeFilter.includes(getCaseTypeValue(d)),
      );
    }

    if (lawyerName) {
      filtered = filtered.filter((d) => d.SALECOD === lawyerName);
    }
    if (expMin != null) {
      filtered = filtered.filter((d) => (d.EXPREAL ?? 0) >= expMin);
    }
    if (expMax != null) {
      filtered = filtered.filter((d) => (d.EXPREAL ?? 0) <= expMax);
    }
    if (lostDayFilter != null) {
      filtered = filtered.filter((d) => (d.LOSTDAY ?? 0) >= lostDayFilter);
    }
    if (!assetStatusFilter.includes("all")) {
      filtered = filtered.filter((d) =>
        assetStatusFilter.includes(getAssetStatus(d)),
      );
    }
    if (assetType !== "all") {
      filtered = filtered.filter(
        (d) =>
          getAssetTypeLabel(d.DATA_TYPE, d.STRNO, d.product) ===
          ASSET_TYPE_LABEL_BY_VALUE[assetType],
      );
    }

    const query = searchContno.trim().toLowerCase();
    if (query) {
      filtered = filtered.filter((d) => {
        const fullName = `${d.SNAM || ""}${d.NAME1 || ""} ${
          d.NAME2 || ""
        }`.toLowerCase();
        return (
          d.CONTNO?.toLowerCase().includes(query) ||
          d.CODE_CONTNO?.toLowerCase().includes(query) ||
          d.ISSUNO?.toLowerCase().includes(query) ||
          d.redCaseNumber?.toLowerCase().includes(query) ||
          fullName.includes(query)
        );
      });
    }

    setFilteredData(filtered);
    setSelectedRowKeys([]);
  }, [
    arrayPay,
    schemaFilter,
    caseTypeFilter,
    lawyerName,
    expMin,
    expMax,
    lostDayFilter,
    assetStatusFilter,
    assetType,
    searchContno,
  ]);

  // ── กำหนดผู้รับผิดชอบ ─────────────────────────────────
  const handleAssignSuccess = useCallback(() => {
    setSelectedRowKeys([]);
    queryData();
  }, [queryData]);

  const hasActiveFilters =
    schemaFilter !== "all" ||
    !!lawyerName ||
    expMin != null ||
    expMax != null ||
    lostDayFilter != null ||
    !assetStatusFilter.includes("all") ||
    assetType !== "all" ||
    !!searchContno.trim();

  const handleResetFilters = useCallback(() => {
    setSchemaFilter("all");
    setSearchContno("");
    setExpMin(null);
    setExpMax(null);
    setLawyerName(undefined);
    setFilteredData(arrayPay);
    setSelectedRowKeys([]);
    setCaseTypeFilter([1, 2, 3]);
    setAssetStatusFilter(["all"]);
    setAssetType("all");
    setLostdayFilter(null);
  }, [arrayPay]);

  // ── Columns ───────────────────────────────────────────
  const columns = [
    {
      title: "ลำดับ",
      key: "index",
      align: "center",
      width: 60,
      render: (_, __, i) => i + 1,
    },
    {
      title: "รายละเอียด",
      key: "detail",
      align: "left",
      width: 260,
      render: (_, r) => (
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div>
            <Text strong>เลขสัญญา {r.CONTNO || "-"}</Text>
          </div>
          <div>
            {`${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim() || "-"}
          </div>
          <div style={{ color: "#888" }}>
            {getSchemaLabel(r.DATA_TYPE)} ・ เลขโฉนด/เลขตัวถัง {r.STRNO || "-"}
          </div>
        </div>
      ),
    },
    {
      title: "คดี",
      key: "case",
      width: 160,
      render: (_, r) => (
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div>
            <Text strong>เลขคดีแดง {r.redCaseNumber || "-"}</Text>
          </div>
          <Space size={4} wrap style={{ marginTop: 2 }}>
            <Tag color={CASE_TYPE_COLOR[getCaseTypeValue(r)] || "default"}>
              {getCaseTypeLabel(r)}
            </Tag>
            <Tag color="cyan">
              {getAssetTypeLabel(r.DATA_TYPE, r.STRNO, r.product)}
            </Tag>
          </Space>
          <div style={{ color: "#888" }}>ผู้รับผิดชอบ: {r.SALECOD}</div>
        </div>
      ),
    },

    {
      title: "ผลสืบทรัพย์",
      key: "statusActiveInvestigate",
      align: "center",
      width: 150,
      render: (_, r) => {
        const meta = getAssetStatusMeta(getAssetStatus(r));
        return (
          <div style={{ fontSize: 13, lineHeight: 1.6 }}>
            <Tag color={meta.color}>{meta.label}</Tag>
            {r.dateOnlineInvestigate && (
              <div style={{ color: "#888", fontSize: 12 }}>
                ส่งสืบ: {formatThaiDate(r.dateOnlineInvestigate)}
              </div>
            )}
            {r.responseDateInvestigate && (
              <div style={{ color: "#888", fontSize: 12 }}>
                ตอบกลับ: {formatThaiDate(r.responseDateInvestigate)}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "การชำระ",
      key: "payment",
      align: "left",
      width: 200,
      render: (_, r) => (
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div>ยอดชำระ : {currencyFormatPoint(r.TOTPRC)} บาท</div>
          <div>
            <span style={{ color: "#888" }}>ยอดหนี้คงเหลือ </span>
            <Text strong style={{ color: "#cf1322" }}>
              {currencyFormatPoint(r.KARBAL)} บาท
            </Text>
          </div>
          <div>วันที่ทำสัญญา : {formatThaiDate(r.SDATE)}</div>
          <div>วันที่ก่อนคิดเบี้ยปรับ : {formatThaiDate(r.FDATE)}</div>
          <div>วันที่ชำระล่าสุด : {formatThaiDate(r.LPAYD)}</div>
        </div>
      ),
    },
    {
      title: "ขาดการติดต่อ",
      key: "payment",
      align: "left",
      width: 200,
      render: (_, r) => (
        <div style={{ fontSize: 13, lineHeight: 1.7 }}>
          <div>ค้าง : {r.EXPREAL} งวด</div>
          <div>ขาดการติดต่อ : {r.LOSTDAY} วัน</div>
        </div>
      ),
    },
    {
      title: "เบี้ยปรับ",
      key: "RES_BEEYPUP",
      align: "left",
      width: 110,
      render: (_, r) => (
        <div style={{ fontSize: 13, lineHeight: 1.6 }}>
          <div>
            <span style={{ color: "#888" }}>เบี้ยปรับ </span>
            {currencyFormatPoint(r.BEEYPUP) ?? "-"}
          </div>
          <div>
            <span style={{ color: "#888" }}>จ่ายแล้ว </span>
            <span style={{ color: "#52c41a" }}>
              {currencyFormatPoint(r.SMPAY_BEEYPUP) ?? "-"}
            </span>
          </div>
          <div>
            <span style={{ color: "#888" }}>คงเหลือ </span>
            <Text
              strong
              style={{ color: r.RES_BEEYPUP > 0 ? "#cf1322" : "#389e0d" }}
            >
              {currencyFormatPoint(r.RES_BEEYPUP) ?? "-"}
            </Text>
          </div>
          {r.PAY_BEEYPUP_DATE != null && (
            <div style={{ color: "#888", fontSize: 12 }}>
              ({formatThaiDate(r.PAY_BEEYPUP_DATE)})
            </div>
          )}
        </div>
      ),
    },
    {
      title: "การจัดการ",
      align: "left",
      width: 110,
      render: (_, r) => (
        <Button
          color="green"
          variant="filled"
          icon={<PlusOutlined />}
          onClick={() => {
            if (
              (r.flagLoanNew === 1 && r.EXPREAL < 4) ||
              (r.flagLoanNew === 2 && r.flagDue === 1 && r.EXPREAL < 4)
            ) {
              message.error(`จำนวนงวดยังไม่เข้าเกณฑ์ส่ง มากกว่า 4 งวด`);
              return null;
            }

            setIsOnceModal(true);
            const type = getAssetTypeLabel(r.DATA_TYPE, r.STRNO, r.product);
            setTypeAssetUse(type);
            setDataSend(r);
          }}
          loading={loading}
          style={{ borderRadius: 8 }}
        >
          ส่งบังคับคดี{" "}
        </Button>
      ),
    },
  ];

  // ── Export helpers ────────────────────────────────────
  const selectedRows = useMemo(
    () => filteredData.filter((r) => selectedRowKeys.includes(getRowKey(r))),
    [filteredData, selectedRowKeys, getRowKey],
  );

  // ไม่ได้เลือกแถวใด ๆ → export ข้อมูลที่กรองไว้ทั้งหมดแทน
  const exportRows = selectedRows.length ? selectedRows : filteredData;

  const exportMenuItems = {
    items: [
      {
        key: "pdf",
        label: "Export PDF",
        icon: <FilePdfOutlined style={{ color: "#c0392b" }} />,
      },
      {
        key: "excel",
        label: "Export Excel",
        icon: <FileExcelOutlined style={{ color: "#27ae60" }} />,
      },
    ],
    onClick: ({ key }) => {
      if (key === "pdf") handlePrintPDF();
      if (key === "excel") handleExportExcel();
    },
  };

  // คอลัมน์ตาม columns ของ Table (ลำดับ / รายละเอียด / สถานะ / การชำระ / เบี้ยปรับ)
  const moneyKeys = ["ยอดชำระ", "เบี้ยปรับ", "จ่ายแล้ว", "คงเหลือ"];

  const buildExportRows = () =>
    exportRows.map((r, i) => ({
      ลำดับ: i + 1,
      เลขสัญญา: r.CONTNO || "",
      "ชื่อ-นามสกุล": `${r.SNAM || ""}${r.NAME1 || ""} ${r.NAME2 || ""}`.trim(),
      บัญชี: getSchemaLabel(r.DATA_TYPE),
      "เลขโฉนด/เลขตัวถัง": r.STRNO || "",
      ผู้รับผิดชอบ: r.SALECOD || "",
      สถานะ: getCaseTypeLabel(r),
      ยอดชำระ: parseFloat(r.TOTPRC) || 0,
      วันที่ทำสัญญา: formatDateExport(r.SDATE),
      วันที่ก่อนคิดเบี้ยปรับ: formatDateExport(r.FDATE),
      เบี้ยปรับ: parseFloat(r.BEEYPUP) || 0,
      จ่ายแล้ว: parseFloat(r.SMPAY_BEEYPUP) || 0,
      คงเหลือ: parseFloat(r.RES_BEEYPUP) || 0,
      วันที่จ่ายเบี้ยปรับ: formatDateExport(r.PAY_BEEYPUP_DATE),
    }));

  const handleExportExcel = () => {
    const rows = buildExportRows();
    if (!rows.length) {
      message.warning("ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    const summaryRow = {
      ลำดับ: "",
      เลขสัญญา: "",
      "ชื่อ-นามสกุล": `รวมทั้งหมด ${rows.length} รายการ`,
    };

    const allRows = [...rows, summaryRow];
    const ws = XLSX.utils.json_to_sheet(allRows);
    const keys = Object.keys(rows[0]);

    const evenFill = { patternType: "solid", fgColor: { rgb: "EBF5FF" } };
    const oddFill = { patternType: "solid", fgColor: { rgb: "FFFFFF" } };
    const summaryFill = { patternType: "solid", fgColor: { rgb: "D5E8D4" } };
    const borderStyle = {
      top: { style: "thin", color: { rgb: "CCCCCC" } },
      bottom: { style: "thin", color: { rgb: "CCCCCC" } },
      left: { style: "thin", color: { rgb: "CCCCCC" } },
      right: { style: "thin", color: { rgb: "CCCCCC" } },
    };

    // header
    keys.forEach((_, ci) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: ci });
      if (!ws[cellRef]) return;
      ws[cellRef].s = {
        fill: { patternType: "solid", fgColor: { rgb: "344962" } },
        font: { bold: true, color: { rgb: "FFFFFF" }, sz: 12 },
        alignment: { horizontal: "center", vertical: "center" },
        border: borderStyle,
      };
    });

    // data rows
    rows.forEach((row, ri) => {
      const fill = ri % 2 === 0 ? evenFill : oddFill;
      keys.forEach((key, ci) => {
        const cellRef = XLSX.utils.encode_cell({ r: ri + 1, c: ci });
        if (!ws[cellRef]) ws[cellRef] = { v: "", t: "s" };
        const isNumber = typeof row[key] === "number";
        const isMoney = moneyKeys.includes(key);
        ws[cellRef].s = {
          fill,
          font: { sz: 11 },
          alignment: {
            horizontal: isNumber ? "right" : "left",
            vertical: "center",
          },
          border: borderStyle,
          numFmt: isMoney ? "#,##0.00" : undefined,
        };
      });
    });

    // summary row
    const summaryRowIdx = rows.length + 1;
    keys.forEach((key, ci) => {
      const cellRef = XLSX.utils.encode_cell({ r: summaryRowIdx, c: ci });
      if (!ws[cellRef]) return;
      const isMoney = moneyKeys.includes(key);
      ws[cellRef].s = {
        fill: summaryFill,
        font: { bold: true, sz: 12 },
        alignment: {
          horizontal: isMoney ? "right" : "left",
          vertical: "center",
        },
        border: borderStyle,
        numFmt: isMoney ? "#,##0.00" : undefined,
      };
    });

    ws["!cols"] = keys.map((key) => ({ wch: Math.max(key.length * 2, 12) }));

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "รายงาน");
    XLSX.writeFile(
      wb,
      `รายงานหนี้ที่ขาดการติดต่อ_${dayjs().format("DDMMYYYY")}.xlsx`,
    );
    message.success("Export Excel สำเร็จ");
  };

  const handlePrintPDF = () => {
    if (!exportRows.length) {
      message.warning("ไม่มีข้อมูลสำหรับ Export");
      return;
    }

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });
    const pageWidth = doc.internal.pageSize.getWidth();
    const now = dayjs().format("DD/MM/YYYY HH:mm:ss");

    const drawHeader = (pageNum) => {
      doc.setFont("THSarabunNew", "bold");
      doc.setFontSize(16);
      doc.text("รายงานหนี้ที่ขาดการติดต่อ", pageWidth / 2, 8, {
        align: "center",
      });
      doc.setFont("THSarabunNew", "normal");
      doc.setFontSize(12);
      doc.text(`วันที่พิมพ์ ${now}`, 8, 16);
      doc.text(`หน้าที่ ${pageNum}`, pageWidth - 8, 16, { align: "right" });
    };

    const rows = buildExportRows();
    const tableBody = rows.map((r) =>
      Object.entries(r).map(([key, val]) =>
        // format ตัวเลขเงินให้มี comma ใน PDF
        moneyKeys.includes(key) ? currencyFormatPoint(val) : val,
      ),
    );

    doc.autoTable({
      startY: 20,
      head: [Object.keys(rows[0])],
      body: tableBody,
      headStyles: {
        font: "THSarabunNew",
        fillColor: [52, 73, 94],
        textColor: 255,
        halign: "center",
        fontStyle: "bold",
        fontSize: 10,
      },
      styles: {
        font: "THSarabunNew",
        fontSize: 9, // 14 คอลัมน์ ลดขนาด font ไม่ให้ล้นหน้า
        cellPadding: 1,
        halign: "center",
      },
      columnStyles: {
        2: { halign: "left" }, // ชื่อ-นามสกุล
        5: { halign: "left" }, // ผู้รับผิดชอบ
        7: { halign: "right" }, // ยอดชำระ
        10: { halign: "right" }, // เบี้ยปรับ
        11: { halign: "right" }, // จ่ายแล้ว
        12: { halign: "right" }, // คงเหลือ
      },
      alternateRowStyles: { fillColor: [235, 245, 255] },
      didDrawPage: () =>
        drawHeader(doc.internal.getCurrentPageInfo().pageNumber),
      margin: { top: 20, left: 3, right: 3 },
    });

    doc.save(`รายงานหนี้ที่ขาดการติดต่อ_${dayjs().format("DDMMYYYY")}.pdf`);
  };

  return (
    <>
      <style>{`
      .row-even td { background-color: #f5f8ff !important; }
      .row-odd td  { background-color: #ffffff !important; }
    `}</style>
      <Spin spinning={loading} size="large" tip="Loading...">
        <Card style={{ marginBottom: 10 }}>
          <Divider style={{ fontSize: 20 }}>สัญญารอส่งบังคับคดี</Divider>
          <Card
            size="small"
            title={
              <Space>
                <ReloadOutlined />
                <span>โหลดข้อมูล</span>
              </Space>
            }
            style={{
              marginBottom: 12,
              background: "#fafafa",
              borderRadius: 10,
            }}
          >
            <Row gutter={[16, 12]} align="bottom">
              <Col xs={24} sm={12} md={8} lg={4}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ประเภทการค้นหา
                </Text>
                <div>
                  <Radio.Group
                    options={OPTIONS_CASE_TYPE}
                    value={caseType}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCaseType(value);
                      if (value === 2) setHldnoSearch(0);
                      if (value === 1) setHldnoSearch(4);
                    }}
                  />
                </div>
              </Col>
              <Col xs={24} sm={12} md={6} lg={4}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ค้างงวดตั้งแต่
                </Text>
                <Space.Compact style={{ width: "100%" }}>
                  <InputNumber
                    min={0}
                    placeholder="จำนวนงวด"
                    value={hldnoSearch}
                    onChange={(data) => setHldnoSearch(data)}
                    style={{ width: "80%" }}
                    size="large"
                    disabled={caseType === 2}
                  />
                </Space.Compact>
              </Col>
              <Col xs={24} sm={12} md={6} lg={4}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ขาดการติดต่อ
                </Text>
                <Space.Compact style={{ width: "100%" }}>
                  <InputNumber
                    min={0}
                    placeholder="จำนวนวัน"
                    value={lostDaySearch}
                    onChange={setLostdaySearch}
                    style={{ width: "80%" }}
                    size="large"
                  />
                </Space.Compact>
              </Col>

              <Col flex="auto" style={{ textAlign: "right" }}>
                <Space>
                  <Button
                    color="blue"
                    variant="outlined"
                    icon={<FilterOutlined />}
                    onClick={() => queryData()}
                    style={{ borderRadius: 8 }}
                  >
                    โหลดข้อมูล
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>
          {/* ── แถบกรองข้อมูล ── */}
          <Card
            size="small"
            title={
              <Space>
                <FilterOutlined />
                <span>ตัวกรองข้อมูล</span>
              </Space>
            }
            style={{
              marginBottom: 12,
              background: "#fafafa",
              borderRadius: 10,
            }}
          >
            <Row gutter={[16, 16]} align="bottom">
              <Col xs={24} sm={12} md={8} lg={6}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  บัญชี
                </Text>
                <Select
                  style={{ width: "100%" }}
                  options={OPTIONS_TYPE_WITH_ALL}
                  value={schemaFilter}
                  onChange={setSchemaFilter}
                  size="large"
                />
              </Col>

              <Col xs={24} sm={12} md={16} lg={9}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ค้นหา (เลขที่สัญญา / ชื่อ-นามสกุล / เลขคดีแดง)
                </Text>
                <Input
                  placeholder="เช่น V2-0012430, สมชาย ใจดี, ดำ 123/2569"
                  value={searchContno}
                  onChange={(e) => setSearchContno(e.target.value)}
                  onPressEnter={handleFilter}
                  prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
                  allowClear
                  size="small"
                  style={{ width: "100%" }}
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={4}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ค้างงวด (จาก - ถึง)
                </Text>
                <Space.Compact style={{ width: "100%" }}>
                  <InputNumber
                    min={0}
                    placeholder="จาก"
                    value={expMin}
                    onChange={setExpMin}
                    style={{ width: "50%" }}
                    size="large"
                    disabled={caseType === 2}
                  />
                  <InputNumber
                    min={0}
                    placeholder="ถึง"
                    value={expMax}
                    onChange={setExpMax}
                    style={{ width: "50%" }}
                    size="large"
                    disabled={caseType === 2}
                  />
                </Space.Compact>
              </Col>
              <Col xs={24} sm={12} md={8} lg={5}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ขาดการติดต่อ (จำนวนวัน)
                </Text>
                <InputNumber
                  min={0}
                  placeholder="จำนวนวัน"
                  value={lostDayFilter}
                  onChange={setLostdayFilter}
                  style={{ width: "100%" }}
                  size="large"
                />
              </Col>

              <Col xs={24} sm={12} md={8} lg={5}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ผู้รับผิดชอบ
                </Text>
                <Select
                  style={{ width: "100%" }}
                  options={lawyerOptions}
                  value={lawyerName}
                  onChange={setLawyerName}
                  loading={loadingUseLawyerNames}
                  allowClear
                  showSearch
                  placeholder="ทั้งหมด"
                  size="large"
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={5}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ผลสืบทรัพย์
                </Text>
                <Select
                  mode="multiple"
                  style={{ width: "100%" }}
                  options={OPTIONS_ASSET_STATUS}
                  value={assetStatusFilter}
                  onChange={handleAssetStatusFilterChange}
                  maxTagCount="responsive"
                  size="large"
                />
              </Col>
              <Col xs={24} sm={12} md={8} lg={5}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  ประเภททรัพย์
                </Text>
                <Select
                  style={{ width: "100%" }}
                  options={OPTIONS_ASSET_TYPE}
                  value={assetType}
                  onChange={setAssetType}
                  size="large"
                />
              </Col>
              <Col xs={24} sm={12} md={9}>
                <Text type="secondary" style={{ fontSize: 13 }}>
                  สถานะ
                </Text>
                <div style={{ paddingTop: 6 }}>
                  <Checkbox.Group
                    options={OPTIONS_CASE}
                    value={caseTypeFilter}
                    onChange={setCaseTypeFilter}
                  />
                </div>
              </Col>

              <Col flex="auto" style={{ textAlign: "right" }}>
                <Space wrap>
                  <Button
                    type="primary"
                    icon={<FilterOutlined />}
                    onClick={handleFilter}
                    style={{ borderRadius: 8 }}
                  >
                    กรองข้อมูล
                  </Button>
                  <Button
                    icon={<ReloadOutlined />}
                    onClick={handleResetFilters}
                    style={{ borderRadius: 8 }}
                  >
                    ล้างตัวกรอง
                  </Button>
                  <Dropdown
                    menu={exportMenuItems}
                    disabled={!filteredData.length}
                  >
                    <Button
                      icon={<PrinterOutlined />}
                      style={{ borderRadius: 8 }}
                    >
                      Export <DownOutlined />
                    </Button>
                  </Dropdown>
                </Space>
              </Col>
            </Row>
          </Card>

          {/* ── สรุปตัวกรองที่ใช้อยู่ ── */}
          {hasActiveFilters && (
            <Card
              size="small"
              style={{ background: "#f0f5ff", marginBottom: 12 }}
            >
              <Space split="|" size="large" wrap>
                <span>
                  <strong>ผลการค้นหา:</strong> {filteredData.length} รายการ
                </span>
                {schemaFilter !== "all" && (
                  <span>
                    <strong>บัญชี:</strong> {getSchemaLabel(schemaFilter)}
                  </span>
                )}
                {searchContno && (
                  <span>
                    <strong>ค้นหา:</strong> "{searchContno}"
                  </span>
                )}
                {(expMin != null || expMax != null) && (
                  <span>
                    <strong>ค้างงวด:</strong> {expMin ?? 0} - {expMax ?? "∞"}
                  </span>
                )}
                {lawyerName && (
                  <span>
                    <strong>ผู้รับผิดชอบ:</strong>
                    {lawyerName}
                  </span>
                )}
                {lostDayFilter != null && (
                  <span>
                    <strong>ขาดการติดต่อตั้งแต่:</strong> {lostDayFilter} วัน
                  </span>
                )}
                {!assetStatusFilter.includes("all") && (
                  <span>
                    <strong>ผลสืบทรัพย์:</strong>{" "}
                    {assetStatusFilter
                      .map(
                        (v) =>
                          OPTIONS_ASSET_STATUS.find((o) => o.value === v)
                            ?.label || v,
                      )
                      .join(", ")}
                  </span>
                )}
                {assetType !== "all" && (
                  <span>
                    <strong>ประเภททรัพย์:</strong>{" "}
                    {OPTIONS_ASSET_TYPE.find((o) => o.value === assetType)
                      ?.label || assetType}
                  </span>
                )}
              </Space>
            </Card>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* <Button
              color="blue"
              variant="filled"
              icon={<PlusOutlined />}
              onClick={() => setIsModal(true)}
              disabled={selectedRows.length === 0 || selectedRows.length > 1}
              loading={loading}
              style={{ borderRadius: 8 }}
            >
              ส่งบังคับคดี{" "}
              {selectedRowKeys.length > 0 && ` (${selectedRowKeys.length})`}
            </Button> */}

            <Text
              strong
              style={{
                margin: "10px 0",
              }}
            >
              จำนวนสัญญาทั้งหมด : {arrayPay.length} เคส
              {selectedRowKeys.length > 0
                ? ` (เลือก ${selectedRowKeys.length} รายการ)`
                : " (ไม่เลือกรายการ = Export ข้อมูลทั้งหมด)"}
            </Text>
          </div>
          <Table
            style={{ marginTop: 10 }}
            size="small"
            columns={columns}
            dataSource={filteredData}
            rowKey={getRowKey}
            rowSelection={{
              selectedRowKeys,
              onChange: setSelectedRowKeys,
            }}
            rowClassName={(_, index) =>
              index % 2 === 0 ? "row-even" : "row-odd"
            }
            scroll={{ x: 1300 }}
            pagination={{
              defaultPageSize: 50,
              showSizeChanger: true,
              showTotal: (t) => `ทั้งหมด ${t} รายการ`,
              pageSizeOptions: ["10", "20", "50", "100"],
            }}
          />
        </Card>
      </Spin>

      {/* <AssignLawyerModal
        open={isModal}
        onClose={setIsModal}
        contracts={selectedRows}
        lawyerOptions={lawyerOptions}
        onSuccess={handleAssignSuccess}
      /> */}
      <AssignOnceLawyerModal
        open={isOnceModal}
        onClose={setIsOnceModal}
        contracts={dataSend}
        lawyerOptions={lawyerOptions}
        onSuccess={handleAssignSuccess}
        typeAssetUse={typeAssetUse}
      />
    </>
  );
};

const MainSelectToEnforce = MotionHoc(Main);
export default MainSelectToEnforce;
